import React from "react";
import { render, hydrate } from "react-dom";
const loadedModules = {};

const mount = async (components) => {
  if (typeof window === "undefined") return;
  Object.keys(components).forEach(async (componentName) => {
    const elements = [
      ...document.querySelectorAll(`*[data-react-class=${componentName}]`),
    ];
    // console.log(elements)
    while (elements.length) {
      const el = elements.shift();
      const module =
        loadedModules[componentName] || (await components[componentName]());
      loadedModules[componentName] = module;
      // console.log(`Loading ${componentName}`)
      const Component = module.hydrate || module.default;
      // console.log(el)
      // const data = el.dataset.reactProps ? JSON.parse(el.dataset.reactProps) : {}
      const data = window[el.id.replace(/^react_/, "react_data_")];
      // console.log(data)
      if (el.children.length) {
        hydrate(<Component {...data} />, el);
      } else {
        render(<Component {...data} />, el);
      }
    }
  });
};
export default mount;
